import React from 'react';
import NatContact from '../App_Data/NatContact';

const ContactMultiLignes = ({ icone, refContact }) => (
    <div className="d-flex flex-row my-flex-container">
        <div className="p-0 picto my-flex-item">
            <i className={icone} aria-hidden="true" />
        </div>
        <div className="p-0 my-flex-item text-truncate">{refContact}</div>
    </div>
);

const Contact = ({
    Nat, Libelle, Ref, RefRech, uneLigne, className,
}) => {
    // Verification si champ non vide ou si contact n'est pas de type 'site web'
    if ((Nat === undefined || Nat === 5) || Libelle === undefined || Ref === undefined || RefRech === undefined) return null;
    const nat = NatContact(Nat);

    return (
        <div
            data-toggle="tooltip"
            data-placement="left"
            title={Libelle || nat.lib}
            className={`${className !== undefined ? className : ''}`}
        >
            <a href={`${nat.uri}${RefRech || Ref.replace('\n', ' - ')}`}>
                {uneLigne ? (
                    <div className="text-truncate">{Ref}</div>
                ) : (
                    <ContactMultiLignes icone={nat.icone} refContact={Ref} />
                )}
            </a>
        </div>
    );
};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js